// ** React
import { Suspense, lazy, useEffect } from 'react';

import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router';

// ** Components
import Spinner from 'src/@core/components/Spinner';

// ** Theme Setup
import ThemeComponent from 'src/@core/theme/ThemeComponent';

// ** Hooks
import { useAuth } from 'src/@core/hooks/useAuth';

// ** Contexts
import { LayoutProvider } from 'src/@core/context/LayoutContext';

// ** http
import { httpInterceptor } from 'src/@core/utils/http';

// ** Utils
import eventBus from 'src/@core/utils/event-bus';

// ** Store
import { store } from 'src/store';
import { Provider } from 'react-redux';

// ** Notistack
import { SnackbarProvider } from 'notistack';

// ** Mui X Date Pickers
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ru';

httpInterceptor();

const loadAuthenticatedApp = () => import('./AuthenticatedApp');
const AuthenticatedApp = lazy(loadAuthenticatedApp);

const App = () => {
  const auth = useAuth();
  const { logout } = auth;

  // ** Effects
  useEffect(() => {
    eventBus.subscribe('auth:logout', () => {
      logout();
    });
  }, []);

  const router = createBrowserRouter(createRoutesFromElements(<Route path={'*'} element={<AuthenticatedApp />} />));

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ru'}>
        <LayoutProvider>
          <ThemeComponent>
            <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}>
              <Suspense fallback={<Spinner />}>
                <RouterProvider router={router} />
              </Suspense>
            </SnackbarProvider>
          </ThemeComponent>
        </LayoutProvider>
      </LocalizationProvider>
    </Provider>
  );
};

export default App;
